export const removeMaskPhone = (phone: string) => {
    return phone.replace("(", " ").replace(")", " ").replace("-", " ").split(" ").join("");
}

export const removeMaskCep = (cep: string) => {
    return cep.replace("-", " ").split(" ").join("");
}

export const removeMaskTaxpayerId = (taxpayerId: string) => {
    return taxpayerId.replaceAll(".", " ").replace("-", " ").split(" ").join("");
}